import { BadgeCheck } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { type SalesLead } from '@/models/salesLead'
import { CarrierEligibilityRow } from './CarrierEligibilityRow'

export function CarrierEligibilityCard({ lead, className }: { lead: SalesLead; className?: string }) {
  return (
    <Card className={cn('gap-3', className)}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <BadgeCheck className="size-4" />
          Eligibility
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm">
        <ul className="space-y-2">
          {lead.carrierEligibility.map((row) => (
            <CarrierEligibilityRow key={row.vendor} row={row} />
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}
